import React, { FC } from 'react'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import {
  TranslationDictionary,
  getAuthSignInUrl,
  SERVICES_URL,
  useLocale,
  useQueryUser
} from '@plandi/common'
import { useRouter } from 'next/router'
import clsx from 'clsx'

import { URLS } from 'src/common'
import { useProjectViewStyles } from './project-view.styles'
import { useMutationCreateChatProject } from '../project-mutations'

type ProjectViewContactSellerButtonProps = {
  projectId?: number
  slugName: string
  translate?: TranslationDictionary['data']
  type?: string
  profile?: {
    id?: number
    name?: string
    fullName?: string
    avatarUrl?: string
    slug_name?: string
  }
}

// eslint-disable-next-line max-len
export const ProjectViewContactSellerButton: FC<ProjectViewContactSellerButtonProps> =
  (props) => {
    const classes = useProjectViewStyles()
    const router = useRouter()
    const locale = useLocale()
    const url = SERVICES_URL
    const { data: user } = useQueryUser(locale)
    const mutationCreateChatProject = useMutationCreateChatProject({
      onSuccess: (data) => {
        if (data.id && props.projectId) {
          router.push({
            pathname: URLS.projects.chats.detail,
            query: {
              projectId: props.projectId,
              chatId: data.id,
              slugName:
                props.slugName || router.query.slugName || 'no-slug-name',
              type: 'user'
            }
          })
        }
      }
    })

    const auth = getAuthSignInUrl(
      locale,
      props.type === 'freelancer'
        ? locale === 'ru'
          ? `${url.job}/ru` +
            `/profile-specialist/${props.profile?.slug_name}/${props.profile?.id}/chat`
          : url.job +
            `/profile-specialist/${props.profile?.slug_name}/${props.profile?.id}/chat`
        : props.type === 'company'
        ? locale === 'ru'
          ? `${url.job}/ru` +
            `/profile-company/${props.profile?.slug_name}/${props.profile?.id}/chat`
          : url.job +
            `/profile-company/${props.profile?.slug_name}/${props.profile?.id}/chat`
        : locale === 'ru'
        ? `${url.shop}/ru` + `/${props.slugName}/${props.projectId}`
        : url.shop + `/${props.slugName}/${props.projectId}`
    )

    const handleChangeRouteChat = () => {
      if (props.type === 'freelancer')
        window.location.href =
          locale === 'ru'
            ? `${url.job}/ru` +
              `/profile-specialist/${props.profile?.slug_name}/${props.profile?.id}/chat`
            : url.job +
              `/profile-specialist/${props.profile?.slug_name}/${props.profile?.id}/chat`
      else if (props.type === 'company')
        window.location.href =
          locale === 'ru'
            ? `${url.job}/ru` +
              `/profile-company/${props.profile?.slug_name}/${props.profile?.id}/chat`
            : url.job +
              `/profile-company/${props.profile?.slug_name}/${props.profile?.id}/chat`
      else if (props.projectId)
        mutationCreateChatProject.mutate(props.projectId)
    }

    return (
      <Button
        variant="contained"
        color="secondary"
        className={clsx(classes.button)}
        onClick={user ? handleChangeRouteChat : undefined}
        href={!user ? auth : ''}
        disabled={mutationCreateChatProject.isLoading}
        startIcon={
          mutationCreateChatProject.isLoading && <CircularProgress size={20} />
        }
      >
        {props.translate?.shop['project-page']['button-contact']}
      </Button>
    )
  }
